import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div>
      <Helmet>
        <title>Page Not Found | Red Rock Ponds RV Resort</title>
      </Helmet>
      <h4>
        404 Page Not Found
      </h4>
      <Link to="/"> Go back to homepage </Link>
    </div>
  );
};

export default NotFoundPage;
